import { useCallback } from 'react'
import { ToolBarButton } from 'components/ToolBarButton'
import OrderModal from 'modals/OrderModal'
import { useModalContext } from 'providers/Overlays/ModalProvider'
import { ShoppingCart } from 'react-feather'
import type { SideToolBarProps } from 'types'

export const OrderDetailsButton = ({ order }: Partial<SideToolBarProps>) => {
  const { showModal } = useModalContext()
  const showOrder = useCallback(() => {
    if (order) {
      showModal(() => <OrderModal order={order} />)
    }
  }, [order, showModal])
  return (
    <ToolBarButton label="ORDER DETAILS" icon={ShoppingCart} tooltipText="ORDER DETAILS" clickCallback={showOrder} />
  )
}
